//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { INgRedux } from 'ng-redux';

import template from '@legacy-components/content/content-responsive-filters-sidebar.html';
import { ICuralateStore } from '@models/AppState';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ContentResponsiveFiltersSidebar
  extends ReturnType<
    (typeof ContentResponsiveFiltersSidebar)['mapStateToProps']
  > {}

class ContentResponsiveFiltersSidebar {
  private static mapStateToProps(state: ICuralateStore) {
    return {
      isManageLabelsModalOpen: false,
      isViewAllLabelsModalOpen: state.viewAllLabels.isModalOpen,
    };
  }

  private readonly unsubscribe: () => void;

  constructor(private readonly $ngRedux: INgRedux) {
    this.unsubscribe = $ngRedux.connect(
      ContentResponsiveFiltersSidebar.mapStateToProps,
    )(this);
  }

  public $onDestroy() {
    this.unsubscribe();
  }

  public getIsModalOpen() {
    return this.isManageLabelsModalOpen || this.isViewAllLabelsModalOpen;
  }
}

angular.module('curalate').component('contentResponsiveFiltersSidebar', {
  bindings: {
    closeClicked: '&',
    initialFilters: '<',
    collectionId: '<',
    excludedSummaryKeys: '<',
  },
  controller: ['$ngRedux', ContentResponsiveFiltersSidebar],
  template,
});
